export default __webpack_public_path__ + "static/inspiration-living-room-ad9e750f123fdf6930ee623bb6a246bd.png";